import React from 'react';
import { InvoiceItemsList, useSendInvoicePrompt } from '../../../../shared/ClientInvoiceItems';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import useOrganizationClientRecordInvoiceItems from '../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import useOrganizationClientRecordInvoices from '../../../../../hooks/api/useOrganizationClientRecordInvoices';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('client-invoice-items-screen-list-content', {
    previewInvoice: 'Preview Invoice',
    sendInvoice: 'Send Invoice',
});

export type InvoiceItemsListContentOwnProps = {
    clientRecordId: string;
    onEditInvoiceLineItem: (invoiceItemId: string) => void;
    onAddInvoiceLineItem: () => void;
    onInvoiceSent: () => void;
    onEditBillingDetails: () => void;
};

export type InvoiceItemsListContentProps = InvoiceItemsListContentOwnProps;

const InvoiceItemsListContent: React.FC<InvoiceItemsListContentProps> = ({
    clientRecordId,
    onEditInvoiceLineItem,
    onAddInvoiceLineItem,
    onInvoiceSent,
    onEditBillingDetails,
}) => {
    const { invoiceItems } = useOrganizationClientRecordInvoiceItems({
        clientRecordId: clientRecordId,
    });
    const { isSendingInvoice, sendInvoice } = useOrganizationClientRecordInvoices({
        clientRecordId,
        onInvoiceSent,
    });
    const { Prompt, onPromptSendInvoice } = useSendInvoicePrompt({
        onSend: sendInvoice,
    });

    return (
        <>
            <ActionButtonLayout
                scrollable
                actions={[
                    {
                        title: intl('sendInvoice'),
                        onPress: onPromptSendInvoice,
                        isDisabled: isSendingInvoice,
                        variant: 'primary',
                        icon: 'Send',
                        show: !!invoiceItems?.items.length,
                        displayInMoreMenu: false,
                        testID: 'send-invoice-button',
                    },
                ]}
            >
                <MainContentContainer>
                    <InvoiceItemsList
                        clientRecordId={clientRecordId}
                        onEditInvoiceLineItem={onEditInvoiceLineItem}
                        onAddInvoiceLineItem={onAddInvoiceLineItem}
                        isInSideDrawer={false}
                        onEditBillingDetails={onEditBillingDetails}
                    />
                </MainContentContainer>
            </ActionButtonLayout>
            {Prompt}
        </>
    );
};

export default React.memo(InvoiceItemsListContent);
